import {
  Button,
  EButtonColorVariant,
  ETextStyleVariant,
  GeneralArrowRightIcon,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { ESearchEventName } from '@/services/analytics/search/types';
import { EProjectSection, trackEventV2 } from '@/services/analytics/trackEventV2';

import { useShowOneWayBanner } from './useShowOneWayBanner';

const ONE_WAY_URL = '/rv-info/one-way-rv-rental';

export const OneWayBanner: React.FC = () => {
  const intl = useIntl();
  const showBanner = useShowOneWayBanner();

  if (!showBanner) {
    return null;
  }

  const handleClick = () => {
    trackEventV2(ESearchEventName.ONE_WAY_BANNER_CLICKED, EProjectSection.MARKETPLACE, {
      source: 'homepage',
      destinationUrl: ONE_WAY_URL,
    });
  };

  return (
    <div className="flex flex-col px-6 py-4 my-4 gap-4 rounded-2xl bg-canvas-200 md:flex-row md:items-center md:justify-between">
      <div className="xl:flex xl:items-center xl:gap-3">
        <Text variant={ETextStyleVariant.MediumBold}>
          <FormattedMessage
            id="sVIq3e"
            defaultMessage="One-Way RV Rentals"
            description="Homepage > One-way banner > Title"
          />
        </Text>{' '}
        <Text variant={ETextStyleVariant.SmallRegular} className="text-secondary-base">
          <FormattedMessage
            id="Z5VOtg"
            defaultMessage="Looking to pick up an RV in one location and drop it off in another?"
            description="Homepage > One-way banner > Subtitle"
          />
        </Text>
      </div>
      <Button
        href={ONE_WAY_URL}
        target="_blank"
        rel="noreferrer"
        onClick={handleClick}
        variant={EButtonColorVariant.Secondary}
        label={
          <span className="inline-flex items-center gap-2">
            {intl.formatMessage({
              id: '6NiQjT',
              defaultMessage: 'One-Way RVs',
              description: 'Homepage > One-way banner > CTA button',
            })}
            <GeneralArrowRightIcon className="w-4 h-4" />
          </span>
        }
      />
    </div>
  );
};
